import { Route, Routes } from "react-router-dom";
import EBook from "./e-book/EBook";
import FunAnimation from "./fun-animation/FunAnimation";

function PictureManage() {
  return (
    <Routes>
      <Route element={<EBook />} path="ebook" />
      <Route element={<FunAnimation />} path="funAnimation" />
    </Routes>
  );
}

export default PictureManage;
